module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_01-7ed24452f19d62d85f7914aaea4df52e.png";